// extracted by mini-css-extract-plugin
export default {"videoBox":"jLVYannjy4tqs7EHnC65","videoPreview":"G0ePiJyhf_rhmYGXOBJq","videoTitle":"WRODwTGxEjTVgMYQC00Q"};